<template>
  <div class="specific-heat-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Q = cmΔt$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：水与油的加热对比 -->
      <div class="canvas-mixed simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 容器 A (水) -->
            <rect x="80" y="80" width="60" height="100" fill="none" stroke="#888" />
            <rect x="81" :y="180 - waterH" width="58" :height="waterH" fill="#00d2ff" opacity="0.6" />
            <text x="80" y="70" fill="#00d2ff" font-size="10">水 (C大)</text>
            <text x="85" y="150" fill="#fff" font-size="12">{{ waterTemp.toFixed(1) }} °C</text>

            <!-- 容器 B (某油) -->
            <rect x="260" y="80" width="60" height="100" fill="none" stroke="#888" />
            <rect x="261" :y="180 - oilH" width="58" :height="oilH" fill="#e67e22" opacity="0.6" />
            <text x="260" y="70" fill="#e67e22" font-size="10">某油 (C小)</text>
            <text x="265" y="150" fill="#fff" font-size="12">{{ oilTemp.toFixed(1) }} °C</text>

            <!-- 加热器 -->
            <line v-if="heating" x1="0" y1="190" x2="400" y2="190" stroke="#ff4757" stroke-width="4" opacity="0.4" />
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>给热量 Q</label>
               <span class="val">{{ heatInput.toFixed(0) }} J</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row center">
               <el-button :type="heating ? 'danger' : 'primary'" size="mini" @mousedown.native="heating = true" @mouseup.native="heating = false">按住加热</el-button>
               <el-button size="mini" @click="reset">重置实验</el-button>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理规律：</strong>相等质量的不同物质，吸收相等的热量，升高的温度不同。<strong>比热容 c 越大</strong>（如水），温度升高越慢。这是沿海地区昼夜温差小的根本原因。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecificHeatViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      heating: false,
      waterTemp: 20,
      oilTemp: 20,
      heatInput: 0,
      running: true
    }
  },
  computed: {
    waterH() { return Math.min(100, 20 + (this.waterTemp - 20)); },
    oilH() { return Math.min(100, 20 + (this.oilTemp - 20)); }
  },
  methods: {
    reset() {
      this.waterTemp = 20;
      this.oilTemp = 20;
      this.heatInput = 0;
    },
    animate() {
       if (!this.running) return;
       
       if (this.heating) {
          this.heatInput += 10;
          // Water c = 4.2, Oil c approx 2.0
          this.waterTemp += 0.05;
          this.oilTemp += 0.12; 
       } else {
          // Cooling
          this.waterTemp = Math.max(20, this.waterTemp - 0.01);
          this.oilTemp = Math.max(20, this.oilTemp - 0.02);
       }

       requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; }
}
</script>

<style scoped lang="scss">
.specific-heat-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .val { font-family: monospace; color: #ff4757; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row.center { display: flex; justify-content: center; gap: 15px; } }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
